import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-table-with-takeaway',
  templateUrl: 'popup-table-with-takeaway.html',
})
export class PopupTableWithTakeaway {
  title: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals) {
    this.title = this.navParams.get('title');
  }


  close() {
    this.viewCtrl.dismiss();
  }

  async optionSelect(option) {
    this.viewCtrl.dismiss({
      option_selected: option
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-table-with-takeaway/popup-table-with-takeaway.ts